<template>
  <div class="prediction-card" :style="{ background: prediction.gradient }">
    <div class="card-header">
      <div class="prediction-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#5b6ef5" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
        </svg>
      </div>

      <div class="card-title-section">
        <router-link :to="{ name: 'MarketView', params: { id: prediction.id, selectedChoice: null } }"
          class="card-title-link">
          <h3 class="card-title">{{ prediction.title }}</h3>
        </router-link>
      </div>

      <div class="percentage-circle" :style="{ '--percentage': prediction.percentage }">
        <span class="percentage-value">{{ prediction.percentage }}%</span>
      </div>
    </div>

    <!-- Combined info and actions block aligned to bottom -->
    <div class="card-bottom-section">
        <div class="card-info">
          <div class="info-item">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 0 0118 0z" />
            </svg>
            <span>Объем: {{ prediction.volume }}</span>
          </div>
          <div class="info-item">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
            <span>Заявок: {{ prediction.ordersCount }}</span>
          </div>
      </div>

      <div class="card-actions">
        <button class="action-btn yes" @click="emit('vote', prediction.id, 'yes')">
          Да
        </button>
        <button class="action-btn no" @click="emit('vote', prediction.id, 'no')">
          Нет
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PredictionCard',
  props: {
    prediction: {
      type: Object,
      required: true
    }
  },
  emits: ['vote'],
  setup(props, { emit }) {
    return {
      emit
    };
  }
};
</script>

<style scoped>
.card-bottom-section {
  margin-top: auto;         
}


.card-title-link {
  text-decoration: none;
  color: inherit;
}

.card-title-link:hover {
  text-decoration: underline;
}
</style>